import { APP_DESCRIPTION, APP_NAME, BASE_URL } from "./constants"

export const generateMeta = ({
	title,
	description,
	canonical,
}: {
	title?: string
	description?: string
	canonical?: string
} = {}) => {
	return [
		{
			title: title ?? APP_NAME,
		},
		{
			name: "description",
			content: description ?? APP_DESCRIPTION,
		},
		{
			tagName: "link",
			rel: "canonical",
			href: canonical
				? `${canonical?.startsWith("https") ? canonical : `${BASE_URL}${canonical}`}`
				: `${BASE_URL}`,
		},
	]
}
